<div>
  <div style="margin-left: 50%; margin-top: 10px; margin-bottom: 10px;">
    
    <button class="noPrint" style="margin-left: 2%;" (click)="exportexcel()" mat-raised-button color="primary">
      Export
    </button>

    <button class="noPrint" style="margin-left: 4%;" mat-raised-button color="primary"
      printSectionId="print-section" [useExistingCss]="true" ngxPrint>
      Print
    </button>

    <button class="noPrint" style="margin-left: 3%" mat-button mat-dialog-close>
      Close
    </button>

  </div>
</div>

<div class="container" id="print-section">

  <!-- HEADER -->
  <div style="display:flex; justify-content:space-between; align-items:center;
              border:1px solid black; padding:10px;">

    <div style="flex:1; text-align:center; font-weight:bold;">
      <h2 style="margin:0; font-size:22px;">
        हिंदुस्थान प्रकाशन संस्था - विवेक पुस्तक प्रकाशन - GST
      </h2>
    </div>

    <div style="white-space:nowrap; font-weight:bold;">
      Date: From {{ startdate | date:'dd-MM-yyyy' }} - To {{ enddate | date:'dd-MM-yyyy' }}
    </div>

  </div>

  <!-- TABLE START -->
  <table style="width:100%; border-collapse:collapse; table-layout:fixed; font-size:14px;">

    <!-- COLUMN WIDTH CONTROL (IMPORTANT FIX) -->
    <colgroup>
      <col style="width:50px;">   <!-- Sr No -->
      <col style="width:110px;">
      <col style="width:200px;">
      <col style="width:90px;">
      <col style="width:140px;">
      <col style="width:140px;">
      <col style="width:90px;">
      <col style="width:90px;">
    </colgroup>

    <!-- HEADER -->
    <tr style="font-weight:700; background:#f2f2f2;">
      <th style="border:1px solid black;">Sr. No.</th>
      <th style="border:1px solid black;">Receipt Date</th>
      <th style="border:1px solid black;">Book Seller Name</th>
      <th style="border:1px solid black;">Address</th>
      <th style="border:1px solid black;">Receipt No</th>
      <th style="border:1px solid black;">GST No</th>
      <th style="border:1px solid black;">HSN</th>
      <th style="border:1px solid black;">Total Amount</th>
    </tr>

    <!-- DATA ROWS -->
    <tr *ngFor="let item of receiptledger; let i=index">

      <td style="border:1px solid black; text-align:center;">{{ i+1 }}</td>

      <td style="border:1px solid black; text-align:center;">
        {{ item.receipt_date | date:'dd-MM-yyyy' }}
      </td>

      <td style="border:1px solid black; text-align:left; padding-left:6px;">
        {{ item.book_seller_name_eng }}
      </td>

      <td style="border:1px solid black; text-align:left; padding-left:6px;">
        {{ item.edistrict }}
      </td>

      <td style="border:1px solid black; text-align:center;">
        {{ item.receipt_no }}
      </td>

      <td style="border:1px solid black; text-align:center;">
        27AAATH0433Q1ZI
      </td>

      <td style="border:1px solid black; text-align:center;">
        4902
      </td>

      <td style="border:1px solid black; text-align:right; padding-right:6px;">
        {{ item.select_entry_amt }}
      </td>

    </tr>

    <!-- TOTAL ROW -->
    <tr>
      <td style="border:1px solid black;"></td>
      <td style="border:1px solid black; font-weight:bold;">Total :</td>
      <td style="border:1px solid black;" colspan="5"></td>
      <td style="border:1px solid black; font-weight:bold; text-align:right; padding-right:6px;">
        {{ total_amt }}
      </td>
    </tr>

  </table>
  <!-- TABLE END -->

</div>